import axios from "axios";

const API_BASE = `${process.env.REACT_APP_API_URL}/api/flows`



export const saveFlow = (flow) => axios.post(API_BASE, flow, {
  headers: {
    'x-email': localStorage.getItem('tenantEmail'),
  },
});
export const getFlows = () => axios.get(API_BASE, {
  headers: {
    'x-email': localStorage.getItem('tenantEmail'),
  },
});
export const getFlow = (id) => axios.get(`${API_BASE}/${id}`, {
  headers: {
    'x-email': localStorage.getItem('tenantEmail'),
  },
});
export const deleteFlow = (id) => axios.delete(`${API_BASE}/${id}`, {
  headers: {
    'x-email': localStorage.getItem('tenantEmail'),
  },
});
